import {
    h,
    ref,
    watch,
    onMounted,
} from 'vue'

import {useStore} from 'vuex'

import {
    AField
} from '../AField'

import './style.scss'

import {
    AInputRenderless
} from './model.js'

import {
    useGetSlots
} from '../utils'

const AInput = {
    name: 'AInput',
    props: {
        modelValue: {
            required: false,
            default: ''
        },
        label: String,
        staticLabel: {
            type: Boolean,
            default: false,
        },
        hint: String,
        error: {
            type: Boolean,
            default: false,
        },
        type: {
            type: String,
            default: 'text'
        },
        autogrow: {
            type: Boolean,
            default: false
        },
        validator: {
            type: Function,
        },
        placeholder: {
            type: String,
            default: '',
        },
        autocomplete: {
            type: String,
            default: '',
        },
        state: {
            type: Object,
            default: () => ({ errorMsg: null })
        },
    },
    inheritAttrs: false,
    setup: (props, ctx) => {

        const $store = useStore()

        const {
            store,
            autogrow,
            numberType,
            validateLat,
        } = AInputRenderless(props, ctx)

        const field = ref(null)
        const control = ref(null)

        let controlNode

        const mess = $store.state.global.mess

        switch (props.type) {
            case 'textarea':
                controlNode = 'textarea'
                break;
            default:
                controlNode = 'input'
                break;
        }

        if (props.type === 'date' || props.type === 'time') {
            store.state.filled = true
        }

        const renderControl = (props) => {

            let options = {
                tabindex: 0,
                id: props.uuid,
                onInput: $e => {
                    ctx.emit('update:modelValue', $e.target.value)
                },
                ...ctx.attrs,
                ref: 'control',
                autocomplete:props.autocomplete?props.autocomplete:'',
                placeholder: props.placeholder,
                class: [
                    'input',
                    props.type === 'textarea' && 'textarea',
                    ctx.attrs.class,
                ],
            }

            switch (props.type) {
                case 'file':
                    options = {
                        ...options,
                        type: props.type,
                        onDragover: ($e) => store.state.dragover = true,
                        onDragleave: () => store.state.dragover = false,
                        onDrop: () => store.state.dragover = false,
                        onInput: $e => {},
                        onChange: $e => {
                            if(props.modelValue) {
                                if($e.target.files.length > 0) {
                                    ctx.emit('update:modelValue', $e.target.files)
                                    ctx.emit('change', $e)
                                }
                            } else {
                                ctx.emit('update:modelValue', $e.target.files)
                                ctx.emit('change', $e)
                            }
                        },
                    }
                    break
                case 'bool':
                    options = {
                        ...options,
                        value: props.modelValue,
                        onChange: ($e) => {
                            ctx.emit('update:modelValue', $e.target.value)
                        }
                    }

                    return h('select', options, [
                        h('option', { value: '', disabled: true, selected: !props.modelValue }, props.placeholder),
                        h('option', { value: 'true' }, 'Да'),
                        h('option', { value: 'false' }, 'Нет')
                    ])

                case 'textarea':
                    options = {
                        ...options,
                        value: props.modelValue,
                    }
                    break
                case 'number':
                    options = {
                        ...options,
                        type: props.type,
                        value: props.modelValue,
                        onKeypress: ($e) => numberType($e)
                    }
                    break
                case 'password':
                    options = {
                        ...options,
                        type: props.type,
                        value: props.modelValue,
                        onKeypress: ($e) => {
                            const isValidLang = validateLat($e)
                            store.state.error = !isValidLang

                            if (isValidLang) {
                                store.errorMsg = ''
                                store.state.errorMsg = ''
                            } else {
                                store.errorMsg = mess.passwordErrorLang
                                store.state.errorMsg = mess.passwordErrorLang
                            }
                        }
                    }
                    break
                default:
                    options = {
                        ...options,
                        type: props.type,
                        value: props.modelValue,
                    }
                    break;
            }

            return h(controlNode, options)
        }

        const renderInput = () => h(AField, {
            class: [store.state, ctx.attrs.class],
            validator: props.validator,
            modelValue: props.modelValue,
         //
            //onInput:()=>{alert()},
            ref: 'field',
            ...props,
            ...store,
        }, {
            control: (props) => renderControl(props),
            ...useGetSlots(ctx.slots, props),
        })

        const validate = () => {
            if (!field.value.validate()) {
                field.value.store.state.error = true
                ctx.emit('error', { status: false, msg: field.value.store.errorMsg })
            }
        }

        if (props.autogrow) {

            onMounted(() => {
                autogrow(control)
            })

            watch(() => props.modelValue, () => {
                autogrow(control)
            })
        }

        return {
            store,
            renderInput,
            validate,
            field,
            control
        }
    },
    render() {
        return this.renderInput()
    },
}

export {
    AInput
}